var CustomLeftNavigation = function () {
	this.pageNavigation = $( ".page-navigation" );
	this.pageLinks = $(".page-navigation li a");
	this.currentUrl = window.location;

	this.bulletClassExpand = "expandable";
	this.bulletClassCollapse = "collapsible";

	this.listClassExpand = "expanded";
	this.listClassCollapse = "collapsed";
};

CustomLeftNavigation.prototype = {
	Setup: function () {
		this._setExpandables();
		this._findCurrentLink();
	},

	_setExpandables: function() {
		var classRef = this;
		var allLists = this.pageNavigation.find( "li" );
		
		allLists.each( function() {
			if( $(this).has( "ul" ).length > 0 ) {
				classRef._addBulletItem( true, this, classRef );
				classRef._setBulletAction( this, classRef );			
			}
			else {
				classRef._addBulletItem(false, this, classRef);
			}
		});
	},

	_addBulletItem: function( isExpandable, listItem, classRef ) {
		var bulletItem = document.createElement( "div" );
		bulletItem.classList.add( "bullet" );

		if( isExpandable ) {
			bulletItem.classList.add(classRef.bulletClassExpand);
		}

		$(listItem).prepend( bulletItem );
	},

	_setBulletAction: function( listItem, classRef ) {
		$(listItem).find( "> ul" ).addClass( classRef.listClassCollapse );

		$(listItem).find( "> .bullet" ).click( function() {
			classRef._bulletClicked( this, classRef );
		});
	},

	_bulletClicked: function( bulletItem, classRef ) {
		var bulletControlledList = $(bulletItem).find("~ ul");

		if( bulletItem.classList.contains( classRef.bulletClassExpand ) ) {
			bulletControlledList.removeClass( classRef.listClassCollapse ).addClass( classRef.listClassExpand );			
			bulletItem.classList.remove(classRef.bulletClassExpand);
			bulletItem.classList.add(classRef.bulletClassCollapse);
		}
		else {
			bulletControlledList.removeClass(classRef.listClassExpand).addClass(classRef.listClassCollapse);			
			bulletItem.classList.remove(classRef.bulletClassCollapse);
			bulletItem.classList.add(classRef.bulletClassExpand);			
		}
	},

	_findCurrentLink: function () {
		var classRef = this;

		var matchingLinks = this.pageLinks.filter(function () {
			return classRef._isCurrentLink(this, classRef);
		});

		if (matchingLinks.length === 1) {
			matchingLinks.parent("li").addClass("active");
			this._expandLists(matchingLinks, classRef);
		}
		else if (matchingLinks.length > 1) {
			matchingLinks = matchingLinks.filter(function () {
				return classRef._isSpecificLink(this, classRef);
			});

			if (matchingLinks.length === 1) {
				matchingLinks.parent("li").addClass("active");
				this._expandLists(matchingLinks, classRef);
			}
		}
	},

	_isCurrentLink: function (link, classRef) {
		if (link.host.toLowerCase() === classRef.currentUrl.host.toLowerCase()) {
			if (link.pathname.toLowerCase() === classRef.currentUrl.pathname.toLowerCase()) {
				return true;
			}
		}

		return false;
	},

	_isSpecificLink: function (link, classRef) {
		if (link.search.toLowerCase() === classRef.currentUrl.search.toLowerCase()) {
			return true;
		}

		return false;
	},

	_expandLists: function (activeLink, classRef) {
		activeLink.parents("ul:not(.page-navigation)").removeClass(classRef.listClassCollapse).addClass(classRef.listClassExpand);
		activeLink.parents("ul:not(.page-navigation)").siblings(".bullet").removeClass(classRef.bulletClassExpand).addClass(classRef.bulletClassCollapse);
	}
};

( new CustomLeftNavigation() ).Setup();